import { useState, useEffect, useRef } from "react";
import MUIDataTable from "./MuiDataTable";
import {
  Box,
  IconButton,
  Typography,
  Stack,
  TextField,
  Button,
} from "@mui/material";
import {
  MRT_ActionMenuItem,
  MRT_ToggleGlobalFilterButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ExpandAllButton,
} from "material-react-table";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { Edit, Delete } from "@mui/icons-material";
const CustomListView = ({
  listData,
  columns,
  handleDataFetch,
  totalCount,
  isLoading = false,
}) => {
  const [data, setData] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  // Add all necessary states
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [rowSelection, setRowSelection] = useState({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  // const fetchData = async (pageIndex, pageSize) => {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const startIndex = pageIndex * pageSize;
  //       const paginatedData = sampleData.slice(startIndex, startIndex + pageSize);

  //       resolve({
  //         data: paginatedData,
  //         totalRows: sampleData.length,
  //       });
  //     }, 500);
  //   });
  // };

  // useEffect(() => {
  //   const loadData = async () => {
  //     setIsLoading(true);
  //     try {
  //       const response = await fetchTableData({
  //         pageIndex: pagination.pageIndex,
  //         pageSize: pagination.pageSize,
  //         filters: columnFilters,
  //         globalSearch: globalFilter,
  //         sorting: sorting
  //       });
  //       setData(response.data);
  //       setTotalRows(response.totalRows);
  //     } catch (error) {
  //       console.error('Error loading data:', error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [pagination.pageIndex, pagination.pageSize, columnFilters, globalFilter, sorting]);

  useEffect(() => {
    setTotalRows(totalCount);
    setData(listData);
  }, [listData, totalCount]);

  useEffect(() => {
    handleDataFetch(
      pagination.pageIndex,
      pagination.pageSize,
      columnFilters,
      sorting
    );
    console.log(columnVisibility);
  }, [pagination.pageIndex, pagination.pageSize,columnFilters, sorting, columnVisibility]);
//   const firstRender = useRef(true);
//   const prevFilters = useRef([]);
//   const hadRealSearch = useRef(false);

//   useEffect(() => {
//     if (firstRender.current) {
//       firstRender.current = false;
//       prevFilters.current = columnFilters;
//       return;
//     }

//     const prevValues = prevFilters.current.map((f) => (f.value || "").trim());
//     const currentValues = columnFilters.map((f) => (f.value || "").trim());

//     // Check if current filters contain any valid search (>= 3 chars)
//     const hasThreeNow = currentValues.some((v) => v.length >= 3);

//     // Check if previous filters contained a valid search
//     const hadThreeBefore = prevValues.some((v) => v.length >= 3);

//     // Store whether we ever had a valid search previously
//     if (hasThreeNow) hadRealSearch.current = true;

//     // CASE 1: Filters cleared & previously had a search → re-fetch full data
//     if (columnFilters.length === 0 && hadRealSearch.current) {
//       handleDataFetch(
//         pagination.pageIndex,
//         pagination.pageSize,
//         columnFilters,
//         sorting
//       );

//       // reset state after clearing
//       hadRealSearch.current = false;
//       prevFilters.current = columnFilters;
//       return;
//     }

//     // CASE 2: Any filter has ≥ 3 chars → fetch
//     if (hasThreeNow) {
//       handleDataFetch(
//         pagination.pageIndex,
//         pagination.pageSize,
//         columnFilters,
//         sorting
//       );
//     }

//     // update prev filters
//     prevFilters.current = columnFilters;
//   }, [columnFilters]);

  //   useEffect(() => {
  //     if (firstRender.current) {
  //       firstRender.current = false;
  //       prevFilters.current = columnFilters;
  //       return;
  //     }

  //     // CASE 1: All filters cleared (empty array)
  //     if (columnFilters.length === 0) {
  //       handleDataFetch(
  //         pagination.pageIndex,
  //         pagination.pageSize,
  //         columnFilters,
  //         sorting
  //       );
  //       prevFilters.current = columnFilters;
  //       return;
  //     }

  //     const values = columnFilters.map((f) => (f.value || "").trim());

  //     // CASE 2: Any filter >= 3 chars
  //     const hasThree = values.some((v) => v.length >= 3);

  //     // CASE 3: A filter was cleared (it was in prevFilters but is now missing)
  //     const wasCleared = prevFilters.current.length > columnFilters.length;

  //     const shouldFetch = hasThree || wasCleared;

  //     if (shouldFetch) {
  //       handleDataFetch(
  //         pagination.pageIndex,
  //         pagination.pageSize,
  //         columnFilters,
  //         sorting
  //       );
  //     }

  //     // update previous filter state
  //     prevFilters.current = columnFilters;
  //   }, [columnFilters]);

  return (
    <MUIDataTable
      columns={columns}
      enableVerticalBorders={false}
      data={data}
      enablePagination={true}
      // enableRowSelection={true}
      enableColumnFilters={true}
      enableGlobalFilter={false}
      enableSorting={true}
      enableEditing={false}
      enableExport={false}
      exportType="csv"
      enableStickyHeader={true}
      isLoading={isLoading}
      renderRowActionMenuItems={({ row, table }) => [
        <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
          icon={<Edit />}
          key="edit"
          label="Edit"
          onClick={() => console.info("Edit")}
          table={table}
        />,
        <MRT_ActionMenuItem
          icon={<Delete />}
          key="delete"
          label="Delete"
          onClick={() => console.info("Delete")}
          table={table}
        />,
      ]}
      onColumnVisibilityChange={setColumnVisibility}
      tableTheme="TenantAdmin"
      icons={{
        ArrowDownwardIcon: (props) => <KeyboardArrowDownIcon {...props} />,
        SyncAltIcon: (props) => (
          <UnfoldMoreIcon
            sx={{ display: "none", fontSize: "medium", ml: "4px" }}
          />
        ),
        DragHandleIcon: (props) => null,
      }}
      // Pass all states
      columnFilters={columnFilters}
      globalFilter={globalFilter}
      sorting={sorting}
      columnVisibility={columnVisibility}
      rowSelection={rowSelection}
      pagination={pagination}
      maxHeight="500px"
      enableInfiniteScroll={true}
      enableRowVirtualization={true}
      // Pass all state handlers

      initialState={{
        pagination: pagination,
        columnFilters: columnFilters,
        globalFilter: globalFilter,
        sorting: sorting,
        rowSelection: rowSelection,
      }}
      onAddNewRow={(row) => console.info("Add new row:", row)}
      onColumnFiltersChange={setColumnFilters}
      onGlobalFilterChange={setGlobalFilter}
      onSortingChange={setSorting}
      // onColumnVisibilityChange={setColumnVisibility}
      onRowSelectionChange={setRowSelection}
      onPaginationChange={setPagination}
      rowCount={totalRows}
      exportRowData
      title="Users"
      muiPaginationProps={{
        rowsPerPageOptions: [5, 10, 20, 50, 100],
      }}
      renderBottomToolbarCustomActions={({ table }) => (
        <>
          <Typography
            variant="body1"
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#374151",
            }}
          >
            {/* Total: {table.getRowCount()} */}
            Count: {table.getRowModel().rows.length}
          </Typography>
        </>
      )}
    />
  );
};

export default CustomListView;
